// extracted by mini-css-extract-plugin
export default {"mywork":"MyWork_mywork__vtqoB","slideChange":"MyWork_slideChange__ictAA"};